import React from 'react';
import { FaCamera, FaRegCheckCircle, FaRegIdCard, FaShieldAlt } from 'react-icons/fa';
import GoBackButton from '../../../../../components/Buttons/GoBackButton';
import NextButton from '../../../../../components/Buttons/NextButton';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { buildAutomationChildTestId, resolveAutomationTestId } from '../../../../../components/InputField/testId';

const PreKYCInfo = ({ isAskForInfo, loading, asLabel, onNext = () => { }, onBack = () => { }, testId }) => {
    const { t } = useTranslation()
    const resolvedTestId = resolveAutomationTestId(testId);
    return (
        <div className={'user-note d-flex flex-column justify-content-center align-items-center'} data-testid={resolvedTestId}>


            <div className="user-note-content" data-testid={buildAutomationChildTestId(resolvedTestId, "content")}>
                <div className="user-note-item" data-testid={buildAutomationChildTestId(resolvedTestId, "id-document-note")}>
                    <FaRegIdCard className="icon" />
                    <span>{t("You will need to provide a valid ID document for verification.")}</span>
                </div>
                <div className="user-note-item" data-testid={buildAutomationChildTestId(resolvedTestId, "selfie-note")}>
                    <FaCamera className="icon" />
                    <span>{t("Be ready to take a live selfie to confirm your identity.")}</span>
                </div>
                <div className="user-note-item" data-testid={buildAutomationChildTestId(resolvedTestId, "photo-quality-note")}>
                    <FaRegCheckCircle className="icon" />
                    <span>{t("Make sure to follow the instructions for a clear and accurate photo capture.")}</span>
                </div>
                <div className="user-note-item" data-testid={buildAutomationChildTestId(resolvedTestId, "security-note")}>
                    <FaShieldAlt className="icon" />
                    <span>{t("Your data is protected with us. We adhere to the highest security and compliance standards.")}</span>
                </div>
            </div>



            {!asLabel && <div className='w-100 ' data-testid={buildAutomationChildTestId(resolvedTestId, "footer")}>

                <ButtonGroupNew
                    testId={buildAutomationChildTestId(resolvedTestId, "navigation")}
                    primaryActionTestIdSuffix="request-kyc-link"
                    onNextClick={onNext}
                    step={2}
                    asLabel={false}
                    loading={loading}
                    hideBackButton
                />

            </div>}




        </div>
    )
}

export default PreKYCInfo
